import React from "react";

const IconArrowDown = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9.394"
      height="12.604"
      viewBox="0 0 9.394 12.604"
    >
      <g id="Group_1944" data-name="Group 1944" transform="translate(1.414 1)">
        <path
          id="Path_3595"
          dataname="Path 3595"
          d="M3892.681,2027.9v10.545"
          transform="translate(-3889.739 -2027.902)"
          fill="none"
          stroke={props.stroke ?? "#000"}
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          id="Path_3596"
          dataname="Path 3596"
          d="M3889.739,2028.218l3.035,3.157,3.531-3.532"
          transform="translate(-3889.739 -2020.771)"
          fill="none"
          stroke={props.stroke ?? "#000"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default IconArrowDown;
